<template>
  <div>
    <MainPanelUI
      headerText="我的助力"
      :hasRecordsBtn="true"
      :note="statusMap.note"
      :amount="statusMap.awardTotalValue || awardTotalValue"
      :showValueBlock="statusMap.showValueBlock"
      :showPrimaryBtn="statusMap.showPrimaryBtn"
      :showPrimaryBtnBadge="statusMap.showPrimaryBtnBadge"
      :primaryBtnBadgeText="statusMap.primaryBtnBadgeText"
      :defaultAvatarImage="defaultAvatarImage"
      @showCouponDetail="handleShowCouponDetail"
      @clickRecordBtn="handleClickRecordBtn"
      v-bind="$attrs"
    >
      <template v-slot:inviteProgress>
        <InviteProgress
          v-if="statusMap.showProgress"
          size="large"
          :total="currentTaskInfo.total"
          :current="currentTaskInfo.current"
          :inviteeInfos="currentTaskInfo.inviteeInfos"
          :emptyAvatarImage="emptyAvatarImage"
          :defaultAvatarImage="defaultAvatarImage"
          @click="handleClickProgress"
          showPhoneNumber
        />
      </template>
      <template v-slot:countdown v-if="statusMap.showCountdown">
        <CountDown :leftMillsec="taskRemainMillSec" @timeend="handleTimeend" />
      </template>
      <template v-slot:primaryBtn>
        <!-- 唤起邀请按钮 -->
        <div
          class="primaryBtnContent"
          v-if="statusMap.primaryBtnType === 'invite'"
          @click="handleClickInviteBtn"
        >
          {{ statusMap.primaryBtnText }}
        </div>
        <!-- 发起助力按钮 -->
        <div
          class="primaryBtnContent"
          v-if="statusMap.primaryBtnType === 'relaunch'"
          @click="handleClickRelaunchBtn"
        >
          {{ statusMap.primaryBtnText }}
        </div>
      </template>
    </MainPanelUI>
    <TaskModal
      :awardTotalValue="awardTotalValue"
      :taskInfo="currentTaskInfo"
      :visible="isShowTaskModal"
      :emptyAvatarImage="emptyAvatarImage"
      :defaultAvatarImage="defaultAvatarImage"
      @launchInvite="handleLaunchInvite"
      @reportExpoEvent="handleReportWithStatus"
      @reportEvent="handleReportEvent"
    />
    <CouponDetailModal
      :visible="isShowCouponDetail"
      @close="handleCloseCouponDetail"
      :couponsData="inviterTaskCouponRewards"
      :isOwned="statusMap.canUseCoupon"
      @reportExpoEvent="handleReportWithStatus"
      @reportEvent="handleReportEvent"
    />
    <WinModal
      :visible="isShowWinModal"
      :awardData="resultAwardsData"
      :awardTotalValue="statusMap.awardTotalValue || awardTotalValue"
      :badgeStr="badgeStr"
      @relaunch="handleRelaunchTask"
      @reportExpoEvent="handleReportWithStatus"
      @close="handleCloseWinModal"
      @reportEvent="handleReportEvent"
    />
    <NoPrizeModal
      :visible="isShowFailModal"
      @close="handleCloseNoPrizeModal"
      @relaunch="handleRelaunchTask"
      :badgeStr="badgeStr"
      @reportExpoEvent="handleReportWithStatus"
      @reportEvent="handleReportEvent"
    ></NoPrizeModal>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';
import MainPanelUI from './MainPanelUI.vue';
import TaskModal from './TaskModal.vue';
import InviteProgress from './InviteProgress';
import CountDown from './Countdown.vue';
import { centToYuan } from '@/components/templates/helper';
import CouponDetailModal from './CouponDetailModal.vue';
import shareMixin from '../mixins/share';
import WinModal from './WinModal.vue';
import NoPrizeModal from './NoPrizeModal';
import { isWxMiniProgram, isWeixinBrowser } from '@/utils';

export default {
  components: {
    MainPanelUI,
    TaskModal,
    InviteProgress,
    CountDown,
    CouponDetailModal,
    WinModal,
    NoPrizeModal
  },
  mixins: [shareMixin],
  data() {
    return {
      resultAwardsData: {}
    };
  },
  props: {
    // 空态头像
    emptyAvatarImage: String,
    // 默认头像
    defaultAvatarImage: String,
    shareTitle: String,
    shareDescription: String,
    shareImage: String,
    isOpenFaceShare: Boolean,
    qrcodePosition: String,
    posterImage: String,
    miniProgramId: Number,
    miniProgramName: String
  },
  methods: {
    ...mapActions('app/inviteEarnCoupon/inviter', [
      'launchInviteTask',
      'refreshTaskInfo'
    ]),
    ...mapMutations('app/inviteEarnCoupon/inviter', [
      'toggleCouponDetail',
      'toggleWinModal',
      'toggleFailModal'
    ]),
    handleTimeend() {
      this.refreshTaskInfo();
    },
    handleClickInviteBtn() {
      this.handleLaunchInvite();
      this.handleReportEvent({
        event: 'invite_boost_coupon_click',
        module_name: this.statusMap.primaryBtnText
      });
    },
    handleLaunchInvite() {
      if (this.currentTaskInfo.userTaskStatus !== 'progressing') {
        return;
      }
      this.launchShare({
        title: this.shareTitle,
        desc: this.shareDescription,
        img: this.shareImage,
        miniIco: this.shareImage,
        posterImg: this.posterImage,
        qrcodePosition: this.qrcodePosition,
        isOpenFaceShare: this.isOpenFaceShare
      });
    },
    handleClickRelaunchBtn() {
      this.handleRelaunchTask();
      this.handleReportEvent({
        event: 'invite_boost_coupon_click',
        module_name: this.statusMap.primaryBtnText
      });
    },
    handleClickRecordBtn() {
      this.$router.push('/play_history');
      this.handleReportEvent({
        event: 'invite_boost_coupon_click',
        module_name: '活动记录'
      });
    },
    handleRelaunchTask() {
      if (this.remainTimes <= 0) {
        this.$hll.toast('发起助力的机会用完啦');
        return;
      }
      this.launchInviteTask();
    },
    handleShowCouponDetail() {
      this.toggleCouponDetail(true);
      this.handleReportEvent({
        event: 'invite_boost_coupon_click',
        module_name: '金额'
      });
    },
    handleCloseCouponDetail() {
      this.toggleCouponDetail(false);
    },
    handleCloseWinModal() {
      this.toggleWinModal(false);
    },
    handleCloseNoPrizeModal() {
      this.toggleFailModal(false);
    },
    handleClickProgress(type) {
      if (type === 'add') {
        this.handleLaunchInvite();
        this.handleReportEvent({
          event: 'invite_boost_coupon_click',
          module_name: '邀请加号'
        });
      }
    },
    handleReportEvent(data) {
      this.$emit('reportEvent', data);
    },
    reportStatus() {
      if (this.currentTaskInfo.userTaskStatus === 'progressing') {
        const isNoInviteYet = this.currentTaskInfo.current === 0;
        return isNoInviteYet
          ? '未邀请人'
          : `邀请${this.currentTaskInfo.current}人`;
      }
      if (
        this.currentTaskInfo.userTaskStatus === 'success' &&
        this.actResult === 'SUCCESS'
      ) {
        return '邀请成功';
      }
      if (this.currentTaskInfo.userTaskStatus === 'fail') {
        return '邀请失败';
      }
      if (this.actResult === 'AccessActFail') {
        return '无法参与活动';
      }
      if (
        this.actResult === 'TaskRiskFail' ||
        this.actResult === 'DistributeRewardFail'
      ) {
        return '邀请成功无法领券';
      }
    },
    handleReportWithStatus(data) {
      this.handleReportEvent({
        ...data,
        page_status: this.reportStatus()
      });
    },
    reportExpo() {
      this.handleReportWithStatus({
        event: 'boost_coupon_invite_expo',
        module_name: '邀请者主页',
        page_status: this.reportStatus()
      });
    },
    async initWxShare() {
      let url;
      try {
        const shareCode = await this.getShareCode();
        url = this.url('invite', shareCode);
      } catch (error) {
        console.error(error);
        return;
      }
      this.shareAct({
        title: this.shareTitle,
        desc: this.shareDescription,
        img: this.shareImage,
        link: url
      });
    }
  },
  computed: {
    ...mapState('app/inviteEarnCoupon/inviter', {
      actResult: state => state.actData.result,
      awardTotalValue: state => state.actData.inviterAmount,
      remainTimes: state => state.actData.remainTimes,
      inviterTaskCouponRewards: state => state.actData.inviterTaskCouponRewards,
      currentTaskInfo: state => state.actData.inviterTaskInfo || {},
      isShowTaskModal: 'isShowTaskModal',
      isShowCouponDetail: 'isShowCouponDetail',
      isShowWinModal: 'isShowWinModal',
      isShowFailModal: 'isShowFailModal'
    }),
    taskRemainMillSec() {
      return this.currentTaskInfo.endTime - this.currentTaskInfo.currentTime;
    },
    badgeStr() {
      return `得${centToYuan(this.awardTotalValue)}元礼包`;
    },
    statusMap() {
      // 参与活动失败
      if (this.actResult !== 'SUCCESS') {
        if (this.actResult === 'AccessActFail') {
          return {
            note: '很遗憾，您无法参与活动',
            showValueBlock: false,
            showCountdown: false,
            showPrimaryBtn: false
          };
        }
        if (this.actResult === 'TaskRiskFail') {
          return {
            note: '您的账号异常，无法领取奖励',
            showValueBlock: false,
            showCountdown: false,
            primaryBtnText: '再次发起助力',
            showPrimaryBtnBadge: true,
            showProgress: true,
            primaryBtnBadgeText: this.badgeStr,
            primaryBtnType: 'relaunch',
            canUseCoupon: false
          };
        }
        if (this.actResult === 'DistributeRewardDelay') {
          return {
            note: '活动太火爆了，请稍后查看奖励',
            showCountdown: false,
            primaryBtnText: '再次发起助力',
            showPrimaryBtnBadge: true,
            primaryBtnBadgeText: this.badgeStr,
            primaryBtnType: 'relaunch',
            showProgress: true,
            canUseCoupon: false
          };
        }
        if (this.actResult === 'DistributeRewardFail') {
          return {
            note: '活动太火爆，奖励已领完，去其他活动看看吧~',
            showValueBlock: false,
            showCountdown: false,
            showProgress: true,
            primaryBtnText: '再次发起助力',
            showPrimaryBtnBadge: true,
            primaryBtnBadgeText: this.badgeStr,
            primaryBtnType: 'relaunch',
            canUseCoupon: false
          };
        }
        return {
          note: '很遗憾，你无法参与活动',
          showValueBlock: false,
          showCountdown: false,
          showPrimaryBtn: false
        };
      }
      // 助力进行中
      if (this.currentTaskInfo.userTaskStatus === 'progressing') {
        const inviteRequireLeft =
          Number(this.currentTaskInfo.total) -
          Number(this.currentTaskInfo.current);
        // 是否还没有邀请
        const isNoInviteYet = this.currentTaskInfo.current === 0;
        return {
          showCountdown: true,
          showProgress: true,
          note: `${
            isNoInviteYet ? '' : '再'
          }邀请 ${inviteRequireLeft} 位好友立即领取礼包`,
          primaryBtnText: `${
            isNoInviteYet ? '' : '再'
          }邀 ${inviteRequireLeft} 人立即领取`,
          primaryBtnType: 'invite'
        };
      }
      // 邀请助力成功&奖励派发成功
      if (this.currentTaskInfo.userTaskStatus === 'success') {
        return {
          note: '邀请成功，恭喜你获得礼包',
          primaryBtnText: '再次发起助力',
          showProgress: true,
          showPrimaryBtnBadge: true,
          primaryBtnBadgeText: this.badgeStr,
          primaryBtnType: 'relaunch',
          canUseCoupon: true,
          awardTotalValue: this.currentTaskInfo.rewardAmount
        };
      }
      // 邀请助力失败
      if (this.currentTaskInfo.userTaskStatus === 'fail') {
        return {
          note: '本次助力已结束，再来一次吧～',
          primaryBtnText: '再次发起助力',
          showProgress: true,
          showPrimaryBtnBadge: true,
          primaryBtnBadgeText: this.badgeStr,
          primaryBtnType: 'relaunch'
        };
      }
      return {};
    }
  },
  async mounted() {
    this.reportExpo();
    if (isWeixinBrowser() || isWxMiniProgram()) {
      // 一进页面就初始化为邀请分享
      await this.initWxShare();
    }
  }
};
</script>

<style lang="less" scoped>
.primaryBtnContent {
  width: 100%;
  height: 100%;
  background: transparent;
  line-height: normal;
  .fc;
}
</style>
